import { JobMatchAction } from "../../models/jobMatchAction";
class ReviewCandidatePullFromJobBoardsController {
    /*@ngInject*/
    constructor($rootScope, $filter, $timeout, $uibModal, jobService, jobMatchService, jobMatchActionsService, modalService, alertsAndNotificationsService, notificationsService) {
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.jobService = jobService;
        this.jobMatchService = jobMatchService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.notificationsService = notificationsService;
    }
    $onInit() {
        // variables
        // initialize uploaded candidate count to zero
        this.candidateCounts = {
            uploadedCandidateCount: 0,
            notProcessedCandidateCount: 0,
            autoMatchedCandidateCount: 0,
            unmatchedCandidateCount: 0,
            manuallyMatchedCandidateCount: 0,
            updatedCandidateCount: 0
        };
        this.candidatesList = [];
        this.candidatesToAssociateList = [];
        this.createJobMatchesObject = {};
        // flags
        // this.loadingCountsInfoFlag = false;
        // this.loadingJobMatchesInfoFlag = false;
        this.selectedAllCandidatesFlag = false;
        this.associatingCandidatesFlag = false;
        this.createJobMatchesObject = {
            companyId: this.$rootScope.userDetails.company.companyId,
            requisitionId: this.jobId,
            candidateIds: [],
            manuallyMatchedFromUI: true,
            jbiTransactionId: this.jbiTransactionId,
            isAddCandidate: false,
            isAssociateCandidate: false,
            overrideNoteDetails: []
        };
        // this.getJobBoardPullCounts(() => {
        //     this.getJobBoardPullMatchInfo();
        // });
        // this.getAllActivityTypes();
        if (this.candidateDtoMap) {
            this.jobBoarPulledCandidates = JSON.parse(this.candidateDtoMap);
            this.candidatesList = this.jobBoarPulledCandidates.candidates;
        }
        this._setDetails();
    }
    _setDetails() {
        let jobId = null;
        if (this.jobId !== '' && this.jobId !== undefined && this.jobId !== null) {
            jobId = this.jobId;
        }
        this._massageCandidateDetails();
        this._getCandidateCounts();
        this.getAllActivityTypes();
        this.setCandidateCount();
    }
    _getCandidateCounts() {
        this.displaySelectDeselectButtonFlag = (this.jobBoarPulledCandidates && this.jobBoarPulledCandidates.create && this.jobBoarPulledCandidates.create.unMatchedCandidateCount !== 0) || (this.jobBoarPulledCandidates && this.jobBoarPulledCandidates.update && this.jobBoarPulledCandidates.update.unMatchedCandidateCount !== 0);
    }
    _massageCandidateDetails() {
        angular.forEach(this.candidatesList, (val, key) => {
            if (_.isNull(val.firstName)) {
                val.firstName = "-";
            }
            if (_.isNull(val.lastName)) {
                val.lastName = "-";
            }
            if (_.isNull(val.email)) {
                val.email = "-";
            }
            if (_.isNull(val.phone)) {
                val.phone = "-";
            }
            val.name = val.firstName + ' ' + val.lastName;
            if (val.mobilePhoneCountryCodePresent) {
                let phoneNumberObject = libphonenumber.parse(val.phone.toString());
                if (phoneNumberObject.phone !== undefined) {
                    val.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
                }
            }
            // floor the match score to the lower integer value.
            val.score = Math.floor(parseFloat(val.score));
            val.selectedFlag = false;
            if (val.score >= val.jobThresholdScore) {
                val.intelligenceScorePassFlag = true;
            }
            let createdCandidateMatchedToJob = false;
            let updatedCandidateMatchedToJob = false;
            if (this.jobBoarPulledCandidates.create) {
                createdCandidateMatchedToJob = !this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames.map(can => can.candidateId).includes(val.candidateId);
            }
            if (this.jobBoarPulledCandidates.update) {
                updatedCandidateMatchedToJob = !this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames.map(can => can.candidateId).includes(val.candidateId);
            }
            val.candidateMatchedToJob = createdCandidateMatchedToJob || updatedCandidateMatchedToJob;
            if (val.candidateMatchedToJob) {
                val.allowManualMatch = false;
            }
            if ((val.score < val.jobThresholdScore) && val.statusOfJobMatch === 'The candidate details updated for job.') {
                val.isCandidateDetailsUpdatedForJob = true;
            }
        });
    }
    setCandidateCount() {
        if (this.jobBoarPulledCandidates) {
            this.candidateCounts = {
                uploadedCandidateCount: this.jobBoarPulledCandidates.uploadedCandidatesCount ? this.jobBoarPulledCandidates.uploadedCandidatesCount : 0,
                notProcessedCandidateCount: this.jobBoarPulledCandidates.create.notProcessedCandidateCount ? this.jobBoarPulledCandidates.create.notProcessedCandidateCount : 0,
                autoMatchedCandidateCount: this.jobBoarPulledCandidates.create.matchedCandidateCount ? this.jobBoarPulledCandidates.create.matchedCandidateCount : 0,
                unmatchedCandidateCount: this.jobBoarPulledCandidates.create.unMatchedCandidateCount ? this.jobBoarPulledCandidates.create.unMatchedCandidateCount : 0,
                manuallyMatchedCandidateCount: this.jobBoarPulledCandidates.create.manuallyMatchedCandidateCount ? this.jobBoarPulledCandidates.create.manuallyMatchedCandidateCount : 0,
                updatedCandidateCount: this.jobBoarPulledCandidates.create.updatedCandidateCount ? this.jobBoarPulledCandidates.create.updatedCandidateCount : 0
            };
        }
    }
    // getJobBoardPullCounts(successCallback) {
    //     this.loadingCountsInfoFlag = true;
    //     this.jobService.getJobBoardPullCounts(this.jobId, this.jbiTransactionId, (data) => {
    //         this.candidateCounts = data;
    //         this.loadingCountsInfoFlag = false;
    //         if(successCallback) {
    //             successCallback();
    //         }
    //     }, (error) => {
    //         this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    //     });
    // }
    // getJobBoardPullMatchInfo() {
    //     this.loadingJobMatchesInfoFlag = true;
    //     this.jobService.getJobBoardPullMatchInfo(this.jbiTransactionId, (data) => {
    //         angular.forEach(data, (val, key) => {
    //             if(_.isNull(val.firstName)) {
    //                 val.firstName = "-";
    //             }
    //             if(_.isNull(val.lastName)) {
    //                 val.lastName = "-";
    //             }
    //             if(_.isNull(val.email)) {
    //                 val.email = "-";
    //             }
    //             if(_.isNull(val.phone)) {
    //                 val.phone = "-";
    //             }
    //             val.name = val.firstName + ' ' + val.lastName;
    //             // floor the match score to the lower integer value.
    //             val.score = Math.floor(parseFloat(val.score));
    //             if(val.score >= val.jobThresholdScore) {
    //                 val.intelligenceScorePassFlag = true;
    //             }
    //             val.selectedFlag = false;
    //             this.candidatesList.push(val);
    //         });
    //         this.loadingJobMatchesInfoFlag = false;
    //     }, (error) => {
    //         this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    //     })
    // }
    toggleSelectAllCandidates() {
        if (this.selectedAllCandidatesFlag) {
            // if selectAllCandidates was already selected, remove all selections
            angular.forEach(this.candidatesList, (val, key) => {
                // if candidate was not already added successfully and was selected, de select it and remove it from associate list
                if (!val.candidateMatchedToJob && val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = false;
                    // if selected is removed, remove from candidates to associate list
                    _.remove(this.candidatesToAssociateList, {
                        candidateId: val.candidateId
                    });
                }
            });
            this.selectedAllCandidatesFlag = false;
        }
        else {
            // if selectAllCandidates was not already selected
            angular.forEach(this.candidatesList, (val, key) => {
                // if candidate was not already added successfully and also not already selected, select it and add to associate list
                if (!val.candidateMatchedToJob && !val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = true;
                    this.candidatesToAssociateList.push(val);
                }
            });
            this.selectedAllCandidatesFlag = true;
        }
    }
    candidateToAssociateToggle(candidate) {
        // if it is selected, add to associate list
        if (candidate.selectedFlag) {
            this.candidatesToAssociateList.push(candidate);
        }
        else {
            // if selected is removed, remove from candidates to associate list
            _.remove(this.candidatesToAssociateList, {
                candidateId: candidate.candidateId
            });
            _.remove(this.createJobMatchesObject.overrideNoteDetails, {
                candidateId: candidate.candidateId
            });
        }
    }
    associateCandidates() {
        angular.forEach(this.candidatesToAssociateList, (val, key) => {
            this.createJobMatchesObject.candidateIds.push(val.candidateId);
        });
        this.associatingCandidatesFlag = true;
        let associatingDialog = bootbox.dialog({
            message: '<p class="text-center">Adding Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        this.jobMatchService.createJobMatches(this.createJobMatchesObject, (data) => {
            this.associatingCandidatesFlag = false;
            associatingDialog.modal('hide');
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(this.candidatesToAssociateList, (val, key) => {
                // find each associated candidate in the original candidates list
                let index = _.findIndex(this.candidatesList, {
                    candidateId: val.candidateId
                });
                // for each candidate, set the added successfully flag to true and selected flag to false
                this.candidatesList[index].candidateMatchedToJob = true;
                this.candidatesList[index].statusOfJobMatch = "Candidate 'manually' added to the job.";
                this.candidatesList[index].selectedFlag = false;
                this.candidatesList[index].jobMatchManuallyCreated = true;
                // update notification payload
                if (this.jobBoarPulledCandidates.update) {
                    if (this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames && this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames.length > 0) {
                        this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames.forEach(candidate => {
                            if (candidate.candidateId == val.candidateId) {
                                this.jobBoarPulledCandidates.update.unMatchedCandidateCount--;
                                this.jobBoarPulledCandidates.update.matchedCandidateCount++;
                                this.jobBoarPulledCandidates.update.matchedCandidateIdAndNames.push(candidate);
                                _.remove(this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames, {
                                    candidateId: val.candidateId
                                });
                            }
                        });
                    }
                }
                if (this.jobBoarPulledCandidates.create) {
                    if (this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames && this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames.length > 0) {
                        this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames.forEach(candidate => {
                            if (candidate.candidateId == val.candidateId) {
                                this.jobBoarPulledCandidates.create.unMatchedCandidateCount--;
                                this.jobBoarPulledCandidates.create.manuallyMatchedCandidateCount++;
                                this.jobBoarPulledCandidates.create.manuallyMatchedCandidateIdAndNames.push(candidate);
                                _.remove(this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames, {
                                    candidateId: val.candidateId
                                });
                            }
                        });
                    }
                }
            });
            this.jobBoarPulledCandidates.candidates = JSON.parse(angular.toJson(this.candidatesList));
            // make the candidates to associate list as empty.
            this.candidatesToAssociateList = [];
            // reload the counts to refresh manually added candidates counts
            this._getCandidateCounts();
            this.alertsAndNotificationsService.showBannerMessage("Candidates have been successfully added to the job", "success");
            this.$rootScope.$broadcast('refreshJobWorkflow', null);
            //save api
            if (this.notificationId) {
                this.notificationsService.saveCandidateResumeNotification(this.notificationId, this.jobBoarPulledCandidates, (data) => {
                    // Do Nothing
                }, error => {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
            if (this.closeCallback) {
                this.closeCallback();
            }
        }, (error) => {
            this.associatingCandidatesFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    showOverrideCandidateSuspensionModal(candidate) {
        let candidateId = candidate.candidateId;
        let candidateName = candidate.name;
        let suspendedMonths = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.numberOfMonthsToWait : candidate.jobLeftCandidateDetailDTO.numberOfMonthsToWait;
        let releaseDate = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.releasedAt : candidate.jobLeftCandidateDetailDTO.leftAt;
        let allowOverride = candidate.allowOverride;
        let releasedJobDetails = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO : candidate.jobLeftCandidateDetailDTO;
        let type = candidate.overrideFor === "RELEASE" ? "release" : "jobLeft";
        if (allowOverride) {
            let warningModal = this.$uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowClass: 'four-dot-five-modal-medium',
                component: 'uploadResumesActionsModal',
                resolve: {
                    candidateId: () => {
                        return candidateId;
                    },
                    candidateName: () => {
                        return candidateName;
                    },
                    suspendedMonths: () => {
                        return suspendedMonths;
                    },
                    releaseDate: () => {
                        return releaseDate;
                    },
                    allowOverride: () => {
                        return allowOverride;
                    },
                    releasedJobDetails: () => {
                        return releasedJobDetails;
                    },
                    type: () => {
                        return type;
                    }
                }
            });
            warningModal.result.then((callbackObject) => {
                if (callbackObject.callbackType == 'save') {
                    let index = _.findIndex(this.candidatesList, {
                        candidateId: candidate.candidateId
                    });
                    this.createJobMatchesObject.overrideNoteDetails.push(ctrl.recruiterDetails);
                    this.candidatesList[index].allowManualMatch = true;
                    this.candidatesList[index].showOverride = false;
                    this.candidatesList[index].candidateMatchedToJob = false;
                    this.candidatesList[index].statusOfJobMatch = 'Candidate is made available for matching.';
                    this.candidatesList[index].selectedFlag = true;
                    this.candidateToAssociateToggle(this.candidatesList[index]);
                }
            }, dismiss => {
                //do nothing
            });
        }
        else {
            let displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot add candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    }
    jobCompare(candidate) {
        let actionObject = new JobMatchAction("Candidate Job Comparison", "CANDIDATE_JOB_COMPARE", true, null);
        candidate.jobMatchJobId = this.jobId;
        candidate.id = candidate.candidateId;
        this.jobMatchActionsService.performAction('reviewCandidatePull', actionObject, candidate, () => {
        }, () => {
        });
    }
    displayProcessedCandidates(activity) {
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(() => {
            let displayCandidatesModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                component: 'uploadResumesTransactionCandidatesModal',
                windowTopClass: 'four-dot-five-modal-large',
                resolve: {
                    jobBoarPulledCandidatesObject: () => {
                        return this.jobBoarPulledCandidates;
                    },
                    activity: () => {
                        return activity;
                    },
                    modalType: () => {
                        return "jobBoardPull";
                    },
                    activityMap: () => {
                        return this.activityMap;
                    }
                }
            });
            displayCandidatesModal.result.then(() => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }, () => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }, 300);
    }
    getAllActivityTypes() {
        this.activityMap = [];
        this.jobService.getActivityTypes((data) => {
            angular.forEach(data, (val, key) => {
                this.activityMap[val.value] = val.name;
            });
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
}
ReviewCandidatePullFromJobBoardsController.$inject = ['$rootScope', '$filter', '$timeout', '$uibModal', 'jobService', 'jobMatchService', 'jobMatchActionsService', 'modalService', 'alertsAndNotificationsService', 'notificationsService'];
// import * as TEMPLATE from './review-candidate-pull-from-job-boards.html';
import * as TEMPLATE from 'raw-loader!./review-candidate-pull-from-job-boards.html';
export const ReviewCandidatePullFromJobBoardsComponent = {
    selector: 'reviewCandidatePullFromJobBoards',
    component: {
        bindings: {
            jbiTransactionId: '@',
            jobId: '@',
            reviewHtmlText: '@',
            candidateDtoMap: '@',
            notificationId: '@',
            closeCallback: '&'
        },
        controller: ReviewCandidatePullFromJobBoardsController,
        template: TEMPLATE.default
        // templateUrl: 'app/components/reviewCandidatePullFromJobBoards/review-candidate-pull-from-job-boards.html'
    }
};
//# sourceMappingURL=review-candidate-pull-from-job-boards.component.js.map